import React from 'react';
import Reagents from "../components/Reagents";


const ReagentsPage = () => {
    return (
        <React.Fragment >
            <Reagents/>
        </React.Fragment>
    );
};

export default ReagentsPage;